<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-s-custom"></i> 客户列表 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection('shanchu')"
                    v-if="perData.allow_dele == 1"
                    >批量删除</el-button
                >
                <el-button
                    type="primary"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection('huiyuan')"
                    v-if="systemSet.isMember == 1"
                    >批量创建会员</el-button
                >
                <!-- <el-select v-model="bar" filterable default-first-option  placeholder="部门" class="handle-select mr10">
                    <el-option v-for="(item,index) in selectData" :key="index" :label="item.kind_name" :value="item.kind_name">
                        <span style="float: right">{{ item.kind_name }}</span>
                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                    </el-option>
                </el-select> -->
                <!-- <label slot="label">业&nbsp;&nbsp;务&nbsp;&nbsp;员</label> -->
                <el-select
                    v-if="systemSet.isstores == 1"
                    style="width: fit-content; margin-right: 20px"
                    v-model="storeBar"
                    filterable
                    clearable
                    default-first-option
                    placeholder="门店"
                    class="handle-select mr10"
                    @change="handleSearch"
                >
                    <el-option v-for="(item, index) in allSelect.store" :key="index" :label="item.store_name" :value="item.store_no">
                        <span style="float: right">{{ item.store_name }}</span>
                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                    </el-option>
                </el-select>
                <el-select
                    style="width: fit-content; margin-right: 20px"
                    v-model="searchY"
                    filterable
                    clearable
                    default-first-option
                    :filter-method="searchSale"
                    @change="refreshs()"
                    placeholder="请选择业务员"
                >
                    <el-option v-for="(item, index) in pull_sale" :key="index" :label="item.staffr_name" :value="item.login_staff">
                        <span style="margin-left: 10px">{{ item.staffr_name }}</span>
                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.login_staff }}</span>
                    </el-option>
                </el-select>
                <el-select
                    style="width: fit-content; margin-right: 20px"
                    v-model="cust_type"
                    filterable
                    clearable
                    placeholder="请选择客户类型"
                >
                    <el-option v-for="(item, index) in allSelect.cust_type" :key="index" :label="item.kind_name" :value="item.kind_no">
                        <span style="float: right">{{ item.kind_name }}</span>
                        <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                    </el-option>
                </el-select>
                <el-input v-model="name" placeholder="请输入客户名称，客户编号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>

                <el-button style="float: right" type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1" @click="handleAdd"
                    >添加</el-button
                >
                <!--                <el-button type="" style="float: right" @click="inExcel">导入</el-button>-->
                <el-button type="" style="float: right" @click="showImpotDialog = true">导入</el-button>
                <el-button type="" style="float: right" @click="outExcel">{{ $t('common.export') }}</el-button>
                <!--                <el-button type="" style="float: right" @click="excelMb">导入模板</el-button>-->
            </div>
            <el-upload
                v-show="false"
                style="border: none; color: #000"
                class="biaoge"
                action=""
                :on-change="inExcels"
                :show-file-list="false"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                :auto-upload="false"
            >
            </el-upload>

            <el-form style="width: 400px; margin-left: 60px" status-icon ref="addData" :model="addData" :rules="rules1" label-width="120px">
            </el-form>
            <el-table
                :data="tableData"
                border
                stripe
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="cust_no" label="客户编号" align="center"></el-table-column>
                <el-table-column prop="cust_name" label="客户名称" align="center"></el-table-column>
                <el-table-column prop="store_name" label="门店" align="center" v-if="systemSet.isstores == 1"></el-table-column>
                <el-table-column prop="custtype.kind_name" label="客户类型" align="center"> </el-table-column>
                <el-table-column label="图片" width="200">
                    <template #default="{ row }">
                        <el-image
                            v-for="(item, index) in row.img_urls"
                            :key="index"
                            :src="item"
                            :preview-src-list="row.img_urls"
                            style="width: 30px; height: 30px; margin-right: 10px"
                        ></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="dept_name" label="部门" width="180" align="center"></el-table-column>
                <el-table-column prop="salesman_name" :label="$t('common.salesman') + '：'" width="180" align="center"></el-table-column>
                <el-table-column label="状态" align="center" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.enable == '1' ? 'success' : scope.row.enable == '0' ? 'danger' : ''">{{
                            scope.row.enable == 1 ? '显示中' : '未显示'
                        }}</el-tag>
                        <el-switch
                            style="margin-left: 5px"
                            v-model="scope.row.enable"
                            :active-value="1"
                            :inactive-value="0"
                            @change="tableDatastates(scope.row)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="build_date" :label="$t('common.createTime')" align="center"></el-table-column>
                <el-table-column label="操作" width="380" align="center" v-if="perData.allow_edit == 1 || perData.allow_dele == 1">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope)" v-if="perData.allow_edit == 1"
                            >{{ $t('common.edit') }}</el-button
                        >
                        <el-button
                            size="mini"
                            type="danger"
                            icon="el-icon-delete"
                            class="red"
                            plain
                            @click="handleDelete(scope)"
                            v-if="perData.allow_dele == 1"
                            >{{ $t('common.delete') }}</el-button
                        >
                        <el-button size="mini" type="success" @click="gotoCustFee(scope.row)" plain>客户工费</el-button>
                        <el-button size="mini" type="warning" icon="el-icon-user" @click="handleCreateMember(scope.row)" plain v-if="systemSet.isMember == 1">创建会员</el-button>
                        <!-- <el-button size="mini" type="info" @click="gotoFeeType(scope.row)" plain>工费类型</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :current-page="pageIndex"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <notice-dialog v-model="noticeData.isshow" v-if="noticeData.isshow"></notice-dialog>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入客户" :visible.sync="showImpotDialog" width="55%" :before-close="handleClose">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <!--  action="http://grapi.tbrjy.com/api/importdtl_sepwgt" -->
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'import_Customer'"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 添加弹出框 -->
        <el-dialog :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="addData_isshow" width="50%">
            <el-form status-icon ref="addData" :model="addData" :rules="rules1" label-width="160px">
                <div class="aaa">
                    <el-form-item label="客户编号" prop="cust_no">
                        <el-input v-model="addData.cust_no" placeholder="为空则系统字段生成，规则：客户类型+序列号" :disabled="!isAdd"></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称" prop="cust_name">
                        <el-input v-model="addData.cust_name"></el-input>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="门店" prop="store_no" v-if="systemSet.isstores == 1">
                        <el-select
                            v-model="addData.store_no"
                            clearable
                            filterable
                            default-first-option
                            @change="changeStore(addData.store_no, '2')"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item, index) in allSelect.store"
                                :key="index"
                                :label="item.store_name"
                                :value="item.store_no"
                            >
                                <span style="margin-left: 10px">{{ item.store_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户类型" prop="cust_type">
                        <el-select v-model="addData.cust_type" filterable clearable placeholder="请选择">
                            <el-option
                                v-for="(item, index) in allSelect.cust_type"
                                :key="index"
                                :label="item.kind_name"
                                :value="item.kind_no.toString()"
                            >
                                <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="部门" prop="dept_no">
                        <el-select v-model="addData.dept_no" clearable filterable multiple placeholder="请选择部门" style="width: 100%">
                            <el-option v-for="(item, index) in pullData.dept" :key="index" :label="item.dept_name" :value="item.dept_no">
                                <span style="margin-left: 10px">{{ item.dept_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.dept_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('common.salesman') + '：'">
                        <label slot="label">业&nbsp;&nbsp;务&nbsp;&nbsp;员</label>
                        <el-select
                            v-model="addData.salesman_no"
                            default-first-option
                            filterable
                            clearable
                            :filter-method="searchSale"
                            @change="refreshs()"
                            placeholder="请选择"
                        >
                            <el-option v-for="(item, index) in pull_sale" :key="index" :label="item.staffr_name" :value="item.login_staff">
                                <span style="margin-left: 10px">{{ item.staffr_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.login_staff }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="联系人">
                        <label slot="label">联&nbsp;&nbsp;系&nbsp;&nbsp;人</label>
                        <el-input v-model="addData.contact"></el-input>
                    </el-form-item>
                    <el-form-item label="邮政编码">
                        <el-input v-model="addData.postal"></el-input>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="联系电话1">
                        <el-input v-model="addData.telephone1"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话2">
                        <el-input v-model="addData.telephone2"></el-input>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="地址1">
                        <label slot="label">地&nbsp;&nbsp;址&nbsp;&nbsp;&nbsp;1</label>
                        <el-input v-model="addData.address1"></el-input>
                    </el-form-item>
                    <el-form-item label="地址2">
                        <label slot="label">地&nbsp;&nbsp;址&nbsp;&nbsp;&nbsp;2</label>
                        <el-input v-model="addData.address2"></el-input>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="邮 箱">
                        <label slot="label">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱</label>
                        <el-input v-model="addData.e_mail"></el-input>
                    </el-form-item>
                    <el-form-item label="省份">
                        <label slot="label">省&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;份</label>
                        <el-select
                            v-model="addData.province_no"
                            default-first-option
                            filterable
                            :filter-method="searchCity2"
                            @change="refreshs()"
                            placeholder="请选择省份"
                        >
                            <el-option
                                v-for="(item, index) in pull_city2"
                                :key="index"
                                :label="item.kind_name"
                                :value="item.kind_no.toString()"
                            >
                                <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="aaa"></div>
                <div class="aaa input">
                    <el-form-item label="最近交易时间">
                        <el-date-picker
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期"
                            v-model="addData.last_time"
                            style="width: 100%"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item :label="$t('common.createTime')">
                        <el-date-picker
                            :disabled="true"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期"
                            v-model="addData.build_date"
                            style="width: 100%"
                        ></el-date-picker>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="定价方案"  v-if="systemSet.ismetalpricing == 1">
                        <el-select v-model="addData.metalpricingplan_no" filterable default-first-option placeholder="请选择">
                            <el-option
                                v-for="(item, index) in allSelect.metalpricingplan"
                                :key="index"
                                :label="item.kind_name"
                                :value="item.kind_no"
                            >
                                <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="工费方案">
                        <el-select v-model="addData.wage" clearable filterable default-first-option placeholder="请选择">
                            <el-option v-for="(item, index) in allSelect.wage" :key="index" :label="item.kind_name" :value="item.kind_no">
                                <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>

                <div class="aaa">
                    <el-form-item label="利息方案">
                        <el-select v-model="addData.interesttype_no" clearable filterable default-first-option placeholder="请选择">
                            <el-option v-for="(item, index) in allSelect.lxPlan" :key="index" :label="item.kind_name" :value="item.kind_no">
                                <span style="margin-left: 10px">{{ item.kind_name }}</span>
                                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.kind_no }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-tag :type="addData.enable == '1' ? 'success' : addData.enable == '0' ? 'danger' : ''">{{
                            addData.enable == '1' ? '显示中' : '未显示'
                        }}</el-tag>
                        <el-switch style="margin-left: 5px" v-model="addData.enable" :active-value="1" :inactive-value="0"> </el-switch>
                    </el-form-item>
                </div>
                <div class="aaa">
                    <el-form-item label="是否门店通用" v-if="systemSet.isstores == 1">
                        <el-tag :type="addData.isstoregeneral == '1' ? 'success' : addData.isstoregeneral == '0' ? 'danger' : ''">{{
                            addData.isstoregeneral == '1' ? '是' : '否'
                        }}</el-tag>
                        <el-switch style="margin-left: 5px" v-model="addData.isstoregeneral" :active-value="1" :inactive-value="0">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="是否月结">
                        <el-tag :type="addData.is_monthly_settle == '1' ? 'success' : addData.is_monthly_settle == '0' ? 'danger' : ''">{{
                            addData.is_monthly_settle == '1' ? '是' : '否'
                        }}</el-tag>
                        <el-switch style="margin-left: 5px" v-model="addData.is_monthly_settle" :active-value="1" :inactive-value="0">
                        </el-switch>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item label="金额尾数：">
                        <el-radio-group v-model="addData.amtRoundingMode">
                            <el-radio :label="-1">遵循系统</el-radio>
                            <el-radio :label="0">四舍五入</el-radio>
                            <el-radio :label="1">直接舍去</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="金额取整：">
                        <el-radio-group v-model="addData.amtInteger">
                            <el-radio :label="-1">遵循系统</el-radio>
                            <el-radio :label="0">不取整</el-radio>
                            <el-radio :label="1">取整</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <el-form-item :label="$t('common.remark')">
                    <el-input type="textarea" v-model="addData.remark" style="width: 100%"></el-input>
                </el-form-item>
                <div class="aaa">
                    <el-form-item label="资料图片（支持扩展名：.jpg .jpeg .png最多上传6张）">
                        <el-upload
                            :action="$baseURL + 'uploadOss_img'"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreviewpt"
                            :on-remove="handleRemovept"
                            :on-success="uploadSuccesspt"
                            :before-upload="beforeUploadpt"
                            :headers="headers"
                            :data="uploadData"
                            :limit="6"
                            :file-list="fileList"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="attachmentImage" :modal="false">
                            <img width="100%" :src="dialogImageUrl" alt="" />
                        </el-dialog>
                    </el-form-item>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="clearTable">取 消</el-button>
                <el-button type="primary" @click="saveAdd('addData')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchData } from '../../api/index';
import { compress } from '../../utils/request';
import store from '../../store/index';
import {
    apisetListVip,
    apialterStatusSetVip,
    apiaddSetVip,
    apimodifySetVip,
    apidelSetVip,
    apiCurrentPermisson,
    apiSSetVipSale,
    apiAllSelectSetVip,
    getImportCust,
    apiSetVipstorepull_staff,
    apiSetVipstoredel
    ,apiCreateMemberCustomer
} from '@/request/api';
export default {
    name: 'basetable',
    data() {
        //自定义表单验证
        var checkAge = (rule, value, callback) => {
            if (!value) {
                callback(new Error('不能为空或者格式错误'));
            } else if (value.indexOf('.') != -1 && value.split('.').length > 2) {
                callback(new Error('请输入正确格式')); //防止输入多个小数点
            } else if (value.indexOf('.') != -1 && value.split('.')[1].length > 2) {
                callback(new Error('请输入小数点后两位')); //小数点后两位
            } else {
                callback();
            }
            // var x = this.editData.data.freelx_amt;//数据
            // var y = String(x).indexOf(".") + 1;//获取小数点的位置
            // var count = String(x).length - y;//获取小数点后的个数
            // if (count>2) {
            //     this.isSub=false;
            //     callback(new Error("最多两位小数"));
            // } else {
            //     this.isSub=true;
            //     callback();
            // }
        };
        var checkMon = (rule, value, callback) => {
            // var x = this.addData.freelx_amt;//数据
            // var y = String(x).indexOf(".") + 1;//获取小数点的位置
            // var count = String(x).length - y;//获取小数点后的个数
            // if (count>2) {
            //     this.isSub=false;
            //     callback(new Error("最多两位小数"));
            // } else {
            //     this.isSub=true;
            //     callback();
            // }
            if (!value) {
                callback(new Error('不能为空或者格式错误'));
            } else if (value.indexOf('.') != -1 && value.split('.').length > 2) {
                callback(new Error('请输入正确格式')); //防止输入多个小数点
            } else if (value.indexOf('.') != -1 && value.split('.')[1].length > 2) {
                callback(new Error('请输入小数点后两位')); //小数点后两位
            } else {
                callback();
            }
        };
        return {
            fileList: [],
            headers: {},
            uploadData: {
                url: 'cust'
            },
            attachmentImage: false, //查看附件图片对话框
            dialogImageUrl: '',
            pullData: [],
            isAdd: true,
            isSub: false,
            bar: '',
            name: '',
            headerImage: '',
            picValue: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: '',
            allSelect: '',
            selectData: [],
            partData: [],
            wayData: [],
            proviceData: [],
            delList: {
                id: [],
                cust_no: []
            },
            addData_isshow: false,
            addData: { isshow: false, scope: null, index: 0, data: {} },
            noticeData: { isshow: false, scope: null, index: 0, data: {} },
            pageTotal: 0,
            pull_city2: [],
            pull_sale: [],
            rules1: {
                // cust_no: [{ required: true, message: '客户编号必填', trigger: 'blur' }],
                cust_name: [{ required: true, message: '客户名称必填', trigger: 'blur' }],
                cust_type: [{ required: true, message: '客户类型必选', trigger: 'change' }],
                store_no: [{ required: true, message: '门店必选', trigger: 'change' }],
                // dept_no:[
                //     {required: true, message: '所属部门必选', trigger: 'change'}
                // ],
                freelx_amt: [{ required: true, validator: checkMon, trigger: 'blur' }]
            },
            searchY: '',
            cust_type: '',
            storeBar: '',
            systemSet: JSON.parse(localStorage.getItem('systemSet')),
            showImpotDialog: false
        };
    },
    mounted() {
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
    },
    created() {
        this.getData();
        this.getPermission();
        this.getpartData();
    },
    // activated() {
    //     this.getData();
    //     this.getPermission();
    //     this.getSalePull();
    //     this.getpartData();
    // },
    methods: {
        uploadSuccesspt(res, file, fileList) {
            let data = {
                uid: Math.floor(Math.random() * 1000) + 10,
                name: `image${Math.floor(Math.random() * 1000) + 10}`,
                url: res.data.imgs
            };
            this.fileList.push(data);

            // 使用 Vue 的 $set 来更新 fileList，以确保响应式更新
            // this.$set(this.fileList, this.fileList.length, data);
        },
        handleRemovept(file, fileList) {
            apiSetVipstoredel({ filePath: file.url }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                } else {
                    this.$message.error(res.msg);
                }
            });

            this.fileList = this.fileList.filter((item) => item.url != file.url);
        },
        handlePictureCardPreviewpt(file) {
            this.dialogImageUrl = file.url;
            this.attachmentImage = true;
        },
        handleAvatarSuccesspt(res, file, fileList, row, col) {
            row.file_urls.push(file);
            this.$message.success('上传成功');
            // this.$set(this.form.events[row.event_index], col, fileList);
        },
        tableRemovept(file, fileList, row, col) {
            let url = file.response.data.filePath;
            apiStyleOrderDelImg({ filePath: url }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.data);
                } else {
                    this.$message.error(res.msg);
                }
            });
            row.file_urls = row.file_urls.filter((item) => item != file);
        },
        beforeUploadpt(file, fileList) {
            let size = file.size / 1024 / 1024 < 5;
            if (this.fileList.length >= 6) {
                this.$message.warning(`当前限制选择 6 个文件`);
                return false;
            }
            if (!size) {
                this.$message.warning(`上传图片大小不能超过 5MB!`);
                return false;
            }
        },
        sans(sa, se) {},
        clearTable() {
            this.addData_isshow = false;
            this.getData();
        },
        // 获取列表信息
        getData() {
            this.$load.show();
            apisetListVip({
                page: this.pageIndex,
                page_size: this.pageSize,
                keyword: this.name,
                staff: this.searchY,
                store: this.storeBar,
                cust_type: this.cust_type
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.page_total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取下拉列表信息
        getpartData() {
            apiAllSelectSetVip({}).then((res) => {
                if (res.code == 2000) {
                    this.allSelect = res.data;
                    this.pull_city2 = res.data.province;
                    this.pull_sale = res.data.salesman_no;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '14'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 启用按钮
        tableDatastates(row) {
            apialterStatusSetVip({ enable: row.enable, cust_no: row.cust_no }).then((res) => {
                if (res.code == 2000) {
                    this.$message({ message: '修改成功', type: 'success' });
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 触发搜索按钮---------------------------------------------------------------
        handleSearch() {
            this.pageIndex = 1;
            this.getData();
        },
        changeStore(e, r) {
            if (typeof e != 'string' && e) {
                e = e.join(',');
            }
            if (r == '2') {
                this.addData.dept_no = '';
            }
            apiSetVipstorepull_staff({
                store_no: e
            }).then((res) => {
                this.pullData = res.data;
                this.$forceUpdate();
            });
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addData_isshow = true;
            this.isAdd = true;
            this.addData = { enable: '1' };
            if (this.allSelect.store) {
                const defaultStore = this.allSelect.store.find((store) => store.isdefault == 1);
                // this.addData.store_no = defaultStore ? defaultStore.store_no : '';
                this.changeStore(defaultStore.store_no);
            }
            this.$forceUpdate();
        },
        // 编辑操作----------------------------------------------------------------------
        handleEdit(scope) {
            this.addData_isshow = true;
            this.isAdd = false;
            this.addData = scope.row;
            this.fileList = [];
            if (scope.row.img_urls) {
                scope.row.img_urls.forEach((item, index) => {
                    let data = {
                        uid: `${index}`,
                        name: `image${index}`,
                        url: item
                    };
                    this.fileList.push(data);
                });
            }

            if (this.allSelect.store) {
                const defaultStore = this.allSelect.store.find((store) => store.isdefault == 1);
                this.changeStore(defaultStore.store_no);
            }
            ['dept_no'].forEach((key) => {
                if (typeof scope.row[key] == 'string') {
                    this.addData[key] = scope.row[key].split(',');
                }
            });
        },
        saveAdd(formName) {
            let data = this.addData;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    ['dept_no'].forEach((key) => {
                        if (data[key]) {
                            data[key] = data[key].join(',');
                        }
                    });
                    let enclosureList = [];
                    this.fileList.forEach((item) => {
                        enclosureList.push(item.url);
                    });
                    data.img_urls = enclosureList;
                    if (this.isAdd) {
                        apiaddSetVip(data).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '添加成功', type: 'success' });
                                this.addData_isshow = false;
                                this.getData();
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    } else {
                        apimodifySetVip(data).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '修改成功', type: 'success' });
                                this.addData_isshow = false;
                                this.getData();
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        // 删除操作---------------------------------------------------------------
        handleDelete(scope) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apidelSetVip({
                        id: scope.row.id
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 多选删除操作
        handleSelectionChange(user) {
            let arr = [];
            let arr1 = [];
            user.forEach(function (item, index, array) {
                arr.push(item.id);
                arr1.push(item.cust_no);
            });
            this.delList.id = arr;
            this.delList.cust_no = arr1;
        },
        delAllSelection(type) {
            if (this.delList.id.length <= 0 || this.delList.cust_no.length <= 0) {
                this.$message({ message: '请先选择需要操作的对象', type: 'error' });
                return;
            }
            let title = type == 'shanchu' ? '批量删除' : '批量创建会员';
            this.$confirm(`此操作将${title}, 是否继续?`, title, {
                confirmButtonText: this.$t('common.confirm') ,
                cancelButtonText: this.$t('common.cancel') ,
                type: 'warning'
            })
                .then(() => {
                    if (type == 'shanchu') {
                        apidelSetVip({
                            id: this.delList.id.join(',')
                        }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: `${title}成功`, type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                        });
                    } else {
                        apiCreateMemberCustomer({
                            cust_no: this.delList.cust_no.join(',')
                        }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: `${title}成功`, type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                    }
                })
                .catch(() => {
                    this.$message({ type: 'info', message: `${title}已取消${title}` });
                });
        },

        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.pageSize = val;
            this.getData();
        },
        searchCity2(val) {
            this.addData.province_no = val;
            if (val) {
                var len = this.allSelect.province;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (len[i].kind_no.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].kind_name.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_city2 = arr;
            } else {
                this.pull_city2 = this.allSelect.province;
            }
        },
        searchSale(val) {
            this.addData.salesman_no = val;
            if (val) {
                var len = this.allSelect.salesman_no;
                var arr = [];
                for (var i = 0; i < len.length; i++) {
                    if (len[i].login_staff.toLowerCase().indexOf(val.toLowerCase()) >= 0 || len[i].staffr_name.indexOf(val) >= 0) {
                        arr.push(len[i]);
                    }
                }
                this.pull_sale = arr;
            } else {
                this.pull_sale = this.allSelect.salesman_no;
            }
        },
        refreshs() {
            this.$forceUpdate();
        },

        gotoCustFee(e) {
            store.commit('Customerlaborcost', e);
            this.$router.push({ path: 'custfee', query: { id: e } });
        },
        // 创建会员---------------------------------------------------------------
        handleCreateMember(row) {
            // 二次确认后再请求接口
            this.$confirm(`确定要为客户「${row.cust_name || row.cust_no}」创建会员吗？`, '提示', {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
            })
                .then(() => {
                    apiCreateMemberCustomer({ cust_no: row.cust_no }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '创建会员成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        gotoFeeType(e) {
            this.$router.push({ path: 'feetype', query: { id: e } });
        },
        // 导入
        inExcel() {
            // getImportCust().then(res => { });
            document.querySelector('.biaoge input').click();
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        // 导入拖拽成功的钩子
        uploadSuccess(res) {
            if (res.code == 2000) {
                this.$message.success(res.msg);
                this.getData();
                this.showImpotDialog = false;
            } else {
                this.$message.error(res.data.info[0]);
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        outTem() {
            this.$axios
                .get(`${this.$baseURL}template_export_Customer`, {
                    params: {
                        token: this.token,
                        type: '客户'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '客户导入模板.xls';
                    link.click();
                });
        },

        // 导入
        inExcels(file) {
            let data = new FormData(); //创建form对象
            data.append('file', file.raw);
            getImportCust(data).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                } else {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i].error + '<br/><br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                }
            });
        },
        // 导出
        outExcel() {
            this.$axios
                .get(this.$baseURL + 'get_export_cust', {
                    params: {
                        token: sessionStorage.getItem('userToken')
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '客户列表.xlsx';
                    link.click();
                });
        },
        // 模板
        excelMb() {
            this.$axios
                .get(this.$baseURL + 'get_export_cust', {
                    params: {
                        token: sessionStorage.getItem('userToken'),
                        type: 1
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '模板.xlsx';
                    link.click();
                });
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ .el-upload--picture-card {
    width: 40px;
    height: 40px;
    line-height: 0;
    .el-icon-plus {
        font-size: 20px;
        margin-top: 10px;
    }
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 40px;
    height: 40px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item-actions {
    span {
        margin-left: -10px;
        width: 5px;
        height: 5px;
        font-size: 15px;
    }
    span + span {
        margin-left: 10px;
    }
}
.handle-box {
    /* display: flex; */
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.aaa {
    display: flex;
}
.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    .centerItem {
        width: 48%;
        text-align: center;
        /deep/ .el-upload--text {
            width: 100%;
            height: 100%;
        }
        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }
    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;
        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    width: 100%;
}
.el-select {
    width: 100%;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
</style>
